import { render, staticRenderFns } from "./main-stripped.vue?vue&type=template&id=6c8c4942&"
import script from "./main-stripped.vue?vue&type=script&lang=js&"
export * from "./main-stripped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports